import {
  GET_ALL_PROGRAMS_REQUEST,
  CREATE_PROGRAM_REQUEST,
  GET_ALL_STATES_REQUEST,
  POST_FILE_REQUEST,
  ADD_CURRENT_PROGRAM,
  GET_ALL_SYSTEMS_REQUEST,
  GET_ALL_EVENTS_REQUEST,
  GET_PROGRAM_ENROLLMENT_METADATA_OF_CURRENT_PROGRAM_REQUEST,
  DELETE_FILE_REQUEST,
  DOWNLOAD_FILE_REQUEST,
  GET_PROGRAM_BY_ID,
} from '../../Constants/ActionTypes'

export function getPrograms(payload) {
  return { type: GET_ALL_PROGRAMS_REQUEST, payload }
}

export function getEvents(payload) {
  return { type: GET_ALL_EVENTS_REQUEST, payload }
}

export function getSystems(payload) {
  return { type: GET_ALL_SYSTEMS_REQUEST, payload }
}

export function createProgram(details) {
  return { type: CREATE_PROGRAM_REQUEST, payload: details }
}

export function getAllStates() {
  return { type: GET_ALL_STATES_REQUEST }
}

export function uploadProgramFile(payload) {
  return { type: POST_FILE_REQUEST, payload }
}

export function deleteProgramFile(payload) {
  return { type: DELETE_FILE_REQUEST, payload }
}

export function downloadProgramFile(payload) {
  return { type: DOWNLOAD_FILE_REQUEST, payload }
}

export function addCurrentProgram(program) {
  return { type: ADD_CURRENT_PROGRAM, payload: program }
}

export function getProgramMetadataOfCurrentProgram(
  programEnrollmentMetadataId,
) {
  return {
    type: GET_PROGRAM_ENROLLMENT_METADATA_OF_CURRENT_PROGRAM_REQUEST,
    payload: programEnrollmentMetadataId,
  }
}

export function getProgramById(payload) {
  return { type: GET_PROGRAM_BY_ID, payload }
}
